import { useState, useEffect } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetail, setDetailParams } from "../../state/cutSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";


const CreateCutMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { detailParams, isNewEntry } = useSelector((state) => state.cut);
    const [submitBtnId, setSubmitBtnId] = useState("")
    const [formData, setFormData] = useState({
        CUTID: "",
        CUT_NAME: "",
        cut_group: "",
        cut_ord: "",
    });

    const { data: cutDetails = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.cut.getcutforupdate,
        queryKey: "fetchCutbyId",
    });


    // Fetch data when `detailParams?.CUTID` exists
    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {
            console.log(detailParams)
            filterDetail({
                data: {
                    CUTID: detailParams.CUTID
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && cutDetails && Object.keys(cutDetails).length > 0) {
            setFormData({
                CUTID: cutDetails.CutId || "",
                CUT_NAME: cutDetails.Cut_Name || "",
                cut_group: cutDetails.Cut_Group || "",
                cut_ord: cutDetails.Cut_Ord || ""
            });


        }
    }, [cutDetails]);



    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const { mutate: addUpdateCut, isPending, isError } = usePost({
        queryKey: "cuts",
        url: apiRoute.cut.addupdateCut,
        successMessage: "Cut saved successfully!",
        onSuccessTasks: () => {
            dispatch(resetDetail());
            if (submitBtnId == 'btnSaveNew') {
                setFormData({
                     CUTID: "",
        CUT_NAME: "",
        cut_group: "",
        cut_ord: "",
                })
            }
            else
                navigate(linksUrl.diamondParamater.cut.cutMaster);
        },
    });

    const onSuccessChkDupCode = (data) => {
        let isDuplicate = 0
        if (isNewEntry && data && data.length > 0) {

            if (data[0].count > 0) {
                if (!toast.isActive("toast_chkcutid")) {
                    toast.error(`Duplicate CutId Found`, {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_chkcutid"
                    })
                }
                isDuplicate = 1
            }
        }
        if (isDuplicate === 0) {
            addUpdateCut({
                data: {
                    ...formData,
                    UID: user.username,
                    pRecStatus: 2,
                }
            });

        }
    }
    const { mutate: funCheckDuplicateCutId } = usePost({
        queryKey: "checkCutCode",
        url: apiRoute.cut.checkCutCode,
        onSuccessTasks: onSuccessChkDupCode
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (!formData.CUTID.trim() || !formData.CUT_NAME.trim()) {
            toast.warn("CUTID and CUT_NAME are required.");
            return;
        }

        if (isNewEntry) {
            funCheckDuplicateCutId({
                data: {
                    CUTID: formData.CUTID
                }
            })
        }
        if (!isNewEntry) {
            addUpdateCut({
                data: {
                    ...formData,
                    UID: user.username,
                    pRecStatus: 1,
                }
            });
        }

    };

    const { data: ordData = [] } = useFetchWithBody({
        url: apiRoute.cut.getNextCutOrd,
        queryKey: "getNextCutOrd",
    });


    useEffect(() => {
        if (isNewEntry) {
            setFormData((prev) => ({
                ...prev,
                cut_ord: ordData.getNextCutOrd,
            }));
        }
    }, [isNewEntry, ordData]);
    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <MainContainer
            pageName="Cut Entry"
            breadcrumbs={["Diamond Parameter", "Cut Master"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.diamondParamater.cut.cutMaster) }}
        >
            <Card className="p-6">
                <CardBody>
                    {isLoading ? (
                        <LoadingCard message="Loading cut details..." />
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <div className="grid gap-4">
                                <Input label="Cut Code" size="sm" maxLength={5}
                                    readOnly={isNewEntry ? false : true} name="CUTID" value={formData.CUTID} onChange={handleChange} isRequired />
                                    <h2 className="text-red-300 " style={{fontSize:"0.7rem"}}>Cut code cannot be longer than 5 characters</h2>
                                <Input label="Cut Name" size="sm" name="CUT_NAME" value={formData.CUT_NAME} onChange={handleChange} isRequired />
                                <Input label="Cut Group" size="sm" name="cut_group" value={formData.cut_group} onChange={handleChange} />
                                <Input label="Cut Order" size="sm" name="cut_ord" type="number" value={formData.cut_ord} onChange={handleChange} />
                                <div className="flex gap-4 justify-center">
                                    <Button type="submit" size="sm" id="btnSave" color="primary" isLoading={isPending}>
                                        {isNewEntry ? "Save" : "Update"}
                                    </Button>
                                    <Button
                                        id="btnSaveNew"
                                        color="success"
                                        type="submit"
                                        size="sm"
                                        variant="shadow"
                                        className="text-white"
                                        startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                    >
                                        Save & New
                                    </Button>
                                </div>

                            </div>
                        </form>
                    )}
                    {isError && <ErrorCard message="Failed to save Cut. Try again." />}
                </CardBody>
            </Card>
        </MainContainer>
    );
};

export default CreateCutMaster;

